import type { ForumHealthRadarPoint } from '../../types';
import ForumHealthRadar from './ForumHealthRadar';

// Side-by-side radar panels: State and Direction shown simultaneously (each
// its own amoeba chart) instead of switching between them via a toggle.
export default function DualMetricRadar({
  statePoints,
  directionPoints,
  currentLabel,
  previousLabel,
  scaleNotes,
}: {
  statePoints?: ForumHealthRadarPoint[];
  directionPoints?: ForumHealthRadarPoint[];
  currentLabel: string;
  previousLabel: string;
  // Per-metric scale-note overrides (the defaults are worded for forum
  // averages; the member-facing view passes its own).
  scaleNotes?: { state?: string; direction?: string };
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div>
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">State</p>
        <ForumHealthRadar
          points={statePoints}
          metric="state"
          currentLabel={currentLabel}
          previousLabel={previousLabel}
          scaleNote={scaleNotes?.state}
        />
      </div>
      <div>
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Direction</p>
        <ForumHealthRadar
          points={directionPoints}
          metric="direction"
          currentLabel={currentLabel}
          previousLabel={previousLabel}
          scaleNote={scaleNotes?.direction}
        />
      </div>
    </div>
  );
}
